import React, { createContext, useContext, useState } from "react";
import { toast } from "react-toastify";
import { fetchFindCompanyUserTableAndFilterSchema } from "model/FindCompanyUserModel";
import { useCommonFilterOptions } from "./CommonFilterOptionsContext";

const FindCompanyUserContext = createContext();

export const FindCompanyUserProvider = ({ children }) => {
  const { fetchMetadataSchema } = useCommonFilterOptions();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [findCompanyUserContextData, setFindCompanyUserContextData] = useState();

  const fetchFindCompanyUserContextData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetchMetadataSchema("metadata:findCompanyUser", () =>
        fetchFindCompanyUserTableAndFilterSchema([])
      );
      if (response?.success) {
        setFindCompanyUserContextData(response?.data);
      } else {
        setError(response?.message || "Unable to fetch find company user metadata");
      }
    } catch (err) {
      toast.error(err?.message || "Something went wrong");
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <FindCompanyUserContext.Provider
      value={{
        fetchFindCompanyUserContextData,
        findCompanyUserContextData,
        loading,
        error,
      }}
    >
      {children}
    </FindCompanyUserContext.Provider>
  );
};

export const useFindCompanyUserContext = () => useContext(FindCompanyUserContext);
